
export const baseUrl = window.location.hostname === "localhost" ? 'http://localhost:4001/api' : '/api';

const IS_PROD_ENV = true;


// export const baseUrl =  'http://localhost:4001/api'
export const S3_BASE_URL = IS_PROD_ENV ? 'https://media.teambdf.org/' : 'https://dev-idiosys.s3.ap-southeast-1.amazonaws.com/';


export const FILE_ICONS = {
        'jpg': { name: 'file-image-o', color: '#1B95E0' },
        'png': { name: 'file-image-o', color: '#1B95E0' },
        'jpeg': { name: 'file-image-o', color: '#1B95E0' },
        'gif': { name: 'file-image-o', color: '#1B95E0' },
        'txt': { name: 'file-text-o', color: '#2E2E2E' },
        'pdf': { name: 'file-pdf-o', color: 'red' },
        'zip': { name: 'file-zip-o', color: '#2E2E2E' },
        'csv': { name: 'file-excel-o', color: '#1B95E0' },
        'default': { name: 'file-o', color: '#2E2E2E' }
}